module.exports = __webpack_public_path__ + "img/ceo_way_skill_02.046a16e6.png";